import { isConnectionError, isTimeoutError } from "../redux/api/ApiClient";
import * as errMessages from "../constants/ErrorMessages";

/**
 * 注文APIでレスポンスを受け取れなかった場合に表示するメッセージを返す。
 *
 * タイムアウトや通信断ではAPIからのエラーメッセージを組み立てられないため、ここで代替メッセージを決める。
 * これらのケースはnginxが諦めた後もPHP側は処理を続行しており、サーバー側で注文が成立している
 * 可能性があるため、単純な再試行を促さない文言にしている（二重注文は実費が発生するため）。
 *
 * @param {Object} errorResponse action.payload.error（=axiosのerror.response）
 * @return {string|null} レスポンスを受け取れている場合はnull（reducer側でAPIのメッセージを使う）
 */
export const resolveOrderConnectionErrorMessage = (errorResponse) => {
  if (!isConnectionError(errorResponse)) {
    return null;
  }

  return isTimeoutError(errorResponse)
    ? errMessages.ERR_ORDER_TIMEOUT
    : errMessages.ERR_ORDER_NETWORK;
};



// WEBPACK FOOTER //
// ./src/utils/orderErrorUtils.js